import React from 'react';
import { Grid, Row, Col } from 'react-bootstrap';
import { Image, Button } from 'react-bootstrap';
import { Form, FormGroup, FormControl, InputGroup } from 'react-bootstrap';
import MapBanner from './shared/MapBanner';
import BestFriend from './shared/BestFriend';

import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { getTranslate, getActiveLanguage } from 'react-localize-redux';

import times from 'lodash/times';

const bestFriendChatEn = require('./../../images/best_friend_chat_en.png');
const bestFriendChatIt = require('./../../images/best_friend_chat_it.png');
const bestFriendChatDe = require('./../../images/best_friend_chat_de.png');
const bestFriendChatEs = require('./../../images/best_friend_chat_es.png');
const bestFriendChatFr = require('./../../images/best_friend_chat_fr.png');

import './reachus.scss';

class ReachUs extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      searchLocation: ''
    };

    this.handleChatSubmit = this.handleChatSubmit.bind(this);
    this.handleSearchLocationChange = this.handleSearchLocationChange.bind(this);
  }

  handleChatSubmit(event) {
    event.preventDefault();
    window.open(`https://www.google.com/maps/dir/?api=1&origin=${this.state.searchLocation}&destination=${this.props.hotel.apiData.address} ${this.props.hotel.apiData.city}`, '_blank');
  }

  handleSearchLocationChange(event) {
    this.setState({searchLocation: event.target.value});
  }

  render() {

    let chatImage;
    switch (this.props.currentLanguage) {
      case 'it':
        chatImage = bestFriendChatIt;
        break;
      case 'de':
        chatImage = bestFriendChatDe;
        break;
      case 'es':
        chatImage = bestFriendChatEs;
        break;
      case 'fr':
        chatImage = bestFriendChatFr;
        break;
      default:
        chatImage = bestFriendChatEn;
        break;
    }

    const hotelStars = times(parseInt(this.props.hotel.apiData.stars), (index) => {
      return (<i className="fa fa-star" key={index}>&nbsp;</i>);
    });

    const reachusInfos = (
      <div className="reachus-infos">
        <h4>{hotelStars}</h4>
        <h4><strong>{this.props.hotel.apiData.name}</strong></h4>
        <h4>{this.props.hotel.apiData.address}</h4>
        <h4>{this.props.hotel.apiData.city}{!!this.props.hotel.apiData.zip ? ` - ${this.props.hotel.apiData.zip}` : null}</h4>
        <br/>
        {this.props.hotel.apiData.phone ? <h4><a href={`tel:${this.props.hotel.apiData.phone}`}>{this.props.hotel.apiData.phone}</a></h4> : null}
        {this.props.hotel.apiData.email ? <h4><a href={`mailto:${this.props.hotel.apiData.email}`}>{this.props.hotel.apiData.email}</a></h4> : null}
      </div>
    );

    const reachusChat = (
      <div className="reachus-chat">
        <Image className="reachus-chat__image center-block" src={chatImage} responsive />
        <br/>
        <div className="reachus-chat__form-holder text-center">
          <Form inline onSubmit={this.handleChatSubmit}>

            <FormGroup controlId="searchLocation">
              <InputGroup>
                <FormControl type="text" placeholder="Via Francesco Baracca Firenze" onChange={this.handleSearchLocationChange} value={this.state.searchLocation} />
                <InputGroup.Button>
                  <Button type="submit"><i className="fa fa-paper-plane" aria-hidden="true"/></Button>
                </InputGroup.Button>
              </InputGroup>
            </FormGroup>

          </Form>
        </div>
      </div>
    );

    return (
      <Grid className="reachus-component">
        
        <MapBanner header={this.props.translate('reach_us.map_banner.header')}
                   title={this.props.translate('reach_us.map_banner.title', {hotel: this.props.hotel.apiData.name})}
                   text={this.props.translate('reach_us.map_banner.text')}
                   showPoi={false}/>

        <Row>
          <Col sm={6} smPush={6} className="text-right hidden-xs">
            {reachusInfos}
          </Col>
          <Col xs={12} className="text-center visible-xs">
            {reachusInfos}
          </Col>
          <Col xs={12} sm={6} smPull={6} className="text-center">
            {reachusChat}
          </Col>
        </Row>

        <BestFriend/>

      </Grid>
    );
  }
}

ReachUs.displayName = 'PagesReachUs';
ReachUs.propTypes = {};
ReachUs.defaultProps = {};

const mapStateToProps = (state) => {
  return { 
      translate: getTranslate(state.locale),
      currentLanguage: getActiveLanguage(state.locale).code,
      hotel: state.hotel
  }
};

export default connect(mapStateToProps)(ReachUs);



// WEBPACK FOOTER //
// ./components/pages/ReachUs.js